import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.html',
  styleUrl: './page-header.scss',
})
export class PageHeader {
  protected readonly mainWebsiteUrl = environment.MAIN_WEBSITE_URL;
  protected readonly envName = environment.ENV_NAME;
}
